module.exports = {
  BED_TYPE_ICON_CLASSES: {
    AirBed: 'icon-bed-size-airbed',
    Crib: 'icon-bed-size-crib',
    DayBed: 'icon-bed-size-daybed',
    ExtendableBed: 'icon-bed-size-pullout',
    Futon: 'icon-bed-size-futon',
    LowerBunkBed: 'icon-bed-size-bunk',
    MurphyBed: 'icon-bed-size-murphy',
    SofaBed: 'icon-bed-size-sofabed',
    Trundle: 'icon-bed-size-trundle',
    UpperBunkBed: 'icon-bed-size-bunk'
  }
};


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/constants.js
 **/